import { useContext } from 'react';

import AuthContext from './AuthContext';

export const UserGuard = ({ children }) => {
  const { userState, ready } = useContext(AuthContext);
  /* eslint-disable no-console */
  return userState?.user && ready ? children : null;
};

export const NoUser = ({ children }) => {
  const { userState, ready } = useContext(AuthContext);
  /* eslint-disable no-console */
  // console.log('NoUser');
  return ready && !userState.user ? children : null;
};

export const ActiveUser = ({ children }) => {
  const { userState } = useContext(AuthContext);

  return userState.user && !userState.user.isBlocked ? children : null;
};
